<template>
  <div class="block two-col">
    <div class="reorder">
      <a href="#" v-on:click="$emit('moveDown', data)" class="move-up">&uarr;</a>
      <a href="#" v-on:click="$emit('moveUp', data)" class="move-down">&darr;</a>
    </div>
    <a href="#" v-on:click="$emit('deleteBlock', this.data)" class="delete">x</a>
    <label class="underline">Two column block</label>
    <div class="row">
      <label>Style options</label>
      <div class="field">
        <select v-model="data.classNames" @change="update">
          <option value="">Image on the left</option>
          <option value="text-left">Image on the right</option>
        </select>
        <label class="label"><br>— Image column</label>
        <Edit-ImageBlock singleOnly="true" :key="'images'+data.id" :data="data" v-on:updateBlock="update" />
      </div>
      <div class="field text-field">
        <label class="label"><br>— Text column</label>
        <div class="control">
          <vue-editor :id="'editor-'+data.id" v-model="data.content"></vue-editor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firestore } from '../main'
import { VueEditor } from 'vue2-editor'
import _ from 'lodash'
import crypto from 'crypto'
import EditImageBlock from '@/components/Edit-ImageBlock'

export default {
  name: 'Edit-TwoColBlock',
  props: ['data'],
  components: {
    VueEditor,
    EditImageBlock
  },
  updated: function() {
    if (!this.data) return
    this.update()
  },
  methods: {
    onUpload(url, id) {
      if (!this.data.images) this.data.images = []
      let index = _.findIndex(this.data.images, { 'id': id })
      if (index < 0) {
        this.data.images.push({ id: crypto.randomBytes(16).toString("hex"), url: url })
      } else {
        this.$set(this.data.images, index, url)
      }
      this.update()
    },
    update: function() {
      this.$emit('updateBlock', this.data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .two-col .nested {
    display: none;
  }
  .two-col .text-field {
    flex: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Edit-TwoColBlock.vue